import { Document, File, Folder, Identifiable, Project } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveDocument(httpClient: HttpClient) {
  return (
    namespace: string,
    type: string,
    { uuid }: Identifiable<Folder>,
    file: File,
  ) =>
    httpClient.sendHttpRequest<Identifiable<Document>>({
      endpoint: `/api/document/upload/${type}/${namespace}/parent/${uuid}`,
      method: HttpMethods.POST,
      data:
        namespace === "planzone"
          ? {
              parentUuid: uuid,
              planzoneUuid: namespace,
            }
          : {
              parentUuid: uuid,
              projectUuid: namespace,
            },
      files: { file },
    });
}

export { saveDocument };
